<template>
  <a-modal
    :title="title"
    :visible="visible"
    :footer="null"
    :width="720"
    destroy-on-close
    @cancel="close"
  >
    <a-spin :spinning="loading">
      <a-alert
        v-if="tip"
        :type="tipType"
        show-icon
        :message="tip"
        style="margin-bottom: 12px"
      />
      <mibo-video-player v-if="playUrl" :src="playUrl" />
      <div v-else-if="!loading" style="padding: 24px; text-align: center; color: rgba(0,0,0,.45)">
        暂无可播放地址
      </div>
      <div v-if="playUrl" style="margin-top: 8px; word-break: break-all; color: rgba(0,0,0,.45); font-size: 12px">
        {{ playUrl }}
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import { streamPlayUrl } from '@/api/mibo/device'
import MiboVideoPlayer from '@/components/mibo/VideoPlayer'

export default {
  name: 'LivePreviewModal',
  components: { MiboVideoPlayer },
  data () {
    return {
      visible: false,
      loading: false,
      title: '实时预览',
      playUrl: '',
      tip: '',
      tipType: 'info',
      record: null
    }
  },
  methods: {
    open (record) {
      this.record = record || null
      this.visible = true
      this.playUrl = ''
      this.tip = ''
      this.title = record && record.deviceName
        ? `实时预览 - ${record.deviceName}`
        : '实时预览'
      if (record && !(record.onlineStatus === 1 || record.onlineStatus === '1')) {
        this.tip = '设备当前离线，可能暂无画面'
        this.tipType = 'warning'
      }
      this.fetchPlayUrl()
    },
    close () {
      this.visible = false
      this.playUrl = ''
      this.tip = ''
      this.record = null
    },
    fetchPlayUrl () {
      if (!this.record || !this.record.id) {
        this.tip = '缺少设备绑定记录'
        this.tipType = 'error'
        return
      }
      this.loading = true
      streamPlayUrl({ id: this.record.id }).then(res => {
        const data = res.data || {}
        const raw = data.playUrl || data.playHlsUrl || ''
        this.playUrl = this.toPlayableUrl(raw)
        if (!this.playUrl) {
          this.tip = '未获取到播放地址'
          this.tipType = 'warning'
        }
      }).catch(err => {
        const msg = (err && (err.message || err.msg)) || '获取播放地址失败，设备可能离线或暂无画面'
        this.tip = msg
        this.tipType = 'error'
        this.playUrl = ''
      }).finally(() => {
        this.loading = false
      })
    },
    /** 后台预览保持 HTTP 8081，规避当前 HTTPS HLS 链路的浏览器加载失败。 */
    toPlayableUrl (url) {
      return String(url || '')
        .trim()
        .replace(/^https:\/\/app\.mibochongwu\.com(?::443)?\//i, 'http://app.mibochongwu.com:8081/')
        .replace(/^http:\/\/app\.mibochongwu\.com(?!:8081)\//i, 'http://app.mibochongwu.com:8081/')
    }
  }
}
</script>
